import { AppNavigation } from "../components/AppNavigation";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "../components/ui/avatar";
import { Badge } from "../components/ui/badge";
import { SocialAccountsManager } from "../components/SocialAccountsManager";

export const SettingsPage = ({ user, logout, token }) => {

  return (
    <div className="min-h-screen bg-background">
      <AppNavigation user={user} logout={logout} />
      
      <main className="lg:ml-64 pt-14 lg:pt-0 pb-20 lg:pb-0 p-6">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Configuración</h1>
            <p className="text-muted-foreground mt-1">
              Gestiona tu perfil y cuentas de redes sociales
            </p>
          </div>

          {/* Profile Section */}
          <Card className="mb-6" data-testid="profile-section">
            <CardHeader>
              <CardTitle>Perfil</CardTitle>
              <CardDescription>Tu información personal</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex items-center gap-6">
                <Avatar className="w-20 h-20">
                  <AvatarImage src={user?.picture} alt={user?.name} />
                  <AvatarFallback className="text-2xl bg-primary/10 text-primary">
                    {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                  </AvatarFallback>
                </Avatar>
                <div className="space-y-1">
                  <h3 className="text-xl font-semibold">{user?.name}</h3>
                  <p className="text-muted-foreground">{user?.email}</p>
                  <Badge variant="secondary" className="mt-2">Plan Gratuito</Badge>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Social Accounts Section */}
          <Card data-testid="social-accounts-section">
            <CardHeader>
              <CardTitle>Cuentas de Redes Sociales</CardTitle>
              <CardDescription>Conecta tus perfiles para publicar en todas las plataformas</CardDescription>
            </CardHeader>
            <CardContent>
              <SocialAccountsManager token={token} />
            </CardContent>
          </Card>

          {/* Danger Zone */}
          <Card className="mt-6 border-destructive/20" data-testid="danger-zone">
            <CardHeader>
              <CardTitle className="text-destructive">Zona de Peligro</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium">Cerrar sesión</p>
                  <p className="text-sm text-muted-foreground">
                    Cierra tu sesión actual
                  </p>
                </div>
                <Button 
                  variant="outline" 
                  className="border-destructive text-destructive hover:bg-destructive/10"
                  onClick={logout}
                  data-testid="logout-settings-btn"
                >
                  Cerrar Sesión
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
};
